import Vue from 'vue'
import Vuex from 'vuex'

import { http } from '@/api/http'
import api from '@/api'
import pushService from '@/plugins/sw-push'

// Modules
import activities from '@/store/modules/activities'
import app from '@/store/modules/app'
import auth from '@/store/modules/auth'
import bubbletool from '@/store/modules/bubbletool'
import carts from '@/store/modules/carts'
import chat from '@/store/modules/chat'
import groups from '@/store/modules/groups'
import jobs from '@/store/modules/jobs'
import kununu from '@/store/modules/kununu'
import news from '@/store/modules/news'
import occasions from '@/store/modules/occasions'
import pages from '@/store/modules/pages'
import posts from '@/store/modules/posts'
import ratings from '@/store/modules/ratings'
import registration from '@/store/modules/registration'
import subscriptions from '@/store/modules/subscriptions'
import topics from '@/store/modules/topics'
import translations from '@/store/modules/translations'
import users from '@/store/modules/users'

Vuex.Store.prototype.http = http
Vuex.Store.prototype.api = api
Vuex.Store.prototype.pushService = pushService

Vue.use(Vuex)

const state = {}
const actions = {}
const mutations = {}
const getters = {}

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  modules: {
    activities,
    app,
    auth,
    carts,
    chat,
    groups,
    jobs,
    kununu,
    news,
    occasions,
    pages,
    posts,
    ratings,
    registration,
    subscriptions,
    topics,
    translations,
    users,
    bubbletool,
  },
  strict: process.env.NODE_ENV !== 'production',
})
